import React, { FC } from "react"
import { Checkbox } from "dash-styled"

interface AIModelActivenessCheckboxProps {
    className?: string
    isActive: boolean
    isProcessing: boolean
    activeText?: string
    inactiveText?: string
    onClick?: () => void
}

export const AIModelActivenessCheckbox: FC<AIModelActivenessCheckboxProps> = ({
    className,
    isActive,
    isProcessing,
    activeText = "Pause model",
    inactiveText = "Resume model",
    onClick
}) => {
    const handleChangeActiveness =
        onClick === undefined
            ? undefined
            : (e: React.SyntheticEvent) => {
                  e.stopPropagation()
                  onClick()
              }

    return (
        <Checkbox
            testId={
                handleChangeActiveness === undefined
                    ? "no-action-model"
                    : isActive
                    ? "pause-model"
                    : "resume-model"
            }
            className={className}
            isChecked={isActive}
            interactive={!isProcessing && handleChangeActiveness !== undefined}
            onChange={handleChangeActiveness}
        >
            {handleChangeActiveness !== undefined && (
                <span className="sr-only">
                    {isActive ? activeText : inactiveText}
                </span>
            )}
        </Checkbox>
    )
}
